<template>
  <div class="chat-app-form position-relative" @submit.prevent="sendNewMessage">

    <b-button
        class="btn mr-1"
        variant="primary"
        type="button"
        @click="sendNewMessage"
    >
      <feather-icon class="text-white" icon="SendIcon" size="20"/>
    </b-button>

    <feather-icon  @click="showEmojis = !showEmojis" v-b-modal.modal-upload class="text-primary-dark mr-1"
                  icon="SmileIcon" size="35"/>

    <b-input-group class="input-group-merge w-100 form-send-message mr-1 ">
      <b-form-textarea
          style="height: 3.5rem"
          v-model="content"
          placeholder="پیام شما ..."
      ></b-form-textarea>
    </b-input-group>

    <feather-icon @click="showUploadModal = true" v-b-modal.modal-upload class="text-warning mr-1"
                  icon="PaperclipIcon" size="35"/>

    <feather-icon @click="showVoiceModal = true" v-b-modal.modal-voice class="text-danger" icon="MicIcon"
                  size="35"/>

    <transition name="slide-up">
      <EmojiPicker class="emoji-container" @SendEmoji="content+= $event.emoji" v-if="showEmojis"/>
    </transition>

    <!--  Upload Pic Modal   -->
    <b-modal
        v-if="showUploadModal"
        id="modal-upload"
        centered
        title="بارگزاری عکس"
        ok-title="ارسال پیام"
        cancelTitle="انصراف"
        @ok="submitChatMediaModal"
    >

      <b-media class="my-2 col-12 mx-auto">
        <template>
          <b-avatar
              class="w-100 cursor-pointer mx-auto"
              ref="previewEl"
              :src="media.file"
              size="300px"
              rounded
              @click.native="$refs.chatMedia.click()"
          >
            <feather-icon v-if="media.file === null" icon="PlusSquareIcon" size="100"/>
          </b-avatar>
        </template>
        <div class="d-none flex-wrap mt-1">
          <b-button
              variant="primary"
          >
            <input
                ref="chatMedia"
                type="file"
                class="d-none"
                accept="image/*"
                @input="uploadMedia"
            >
            <span class="d-none d-sm-inline">+</span>
            <feather-icon
                icon="EditIcon"
                class="d-inline d-sm-none"
            />
          </b-button>
        </div>
      </b-media>
    </b-modal>
    <!--  Upload Pic Modal End  -->

    <!-- Voice Message   -->
    <b-modal
        v-if="showVoiceModal"
        id="modal-voice"
        centered
        title="ارسال صوت"
        :ok-disabled="showVoiceSubmit"
        ok-title="ارسال"
        cancelTitle="انصراف"
        @cancel="closeVoiceModal"
        @ok="uploadVoice"
    >

      <AudioRecorder @getAudioBlob="SetAudioBlob" ref="Recorder"/>

      <div style="height: 10rem" class="w-100 d-flex flex-column align-items-center justify-content-center rounded-6 ">
        <b-button v-if="!IsRecording" variant="primary" type="button" @click.stop="StartRecording">
          <feather-icon class="text-white" icon="PlayIcon" size="20"/>
        </b-button>
        <div v-else @click="StopRecording" class="blob red"></div>
        <div class="flex items-center flex-row-reverse gap-3 my-2">
          <small>{{ Seconds }}</small>
          :
          <small>{{ Minutes }}</small>
          :
          <small>{{ Hours }}</small>
        </div>
        <audio v-if="VoiceMessage!==''" :src="GenerateAudioSrc" controls></audio>
      </div>

    </b-modal>
    <!--  Voice Message End  -->

  </div>
</template>

<script>
import ChatHeader from '@/views/components/newChat/ChatHeader.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmojiPicker from '@/views/components/chat/EmojiPicker.vue'
import {
  BAlert,
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput, BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {MediaCreateFileRequest, MediaCreateOnlineChatMediaRequest} from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import AudioRecorder from "@/views/components/chat/AudioRecorder.vue";

export default {
  name: 'ChatEntries',
  data() {
    return {
      content: '',
      media:{
        file:null,
        type:2
      },
      showVoiceModal:false,
      showUploadModal:false,
      showEmojis:false,

      // Voice variables
      IsRecording: false,
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      AudioStopWatch: null,
      VoiceMessage: '',
      fileData: {
        base64: '',
        baseImgUrl: '',
        priority: 0
      },
      showVoiceSubmit: true,
    }
  },
  computed: {
    GenerateAudioSrc() {
      if (this.VoiceMessage) {
        return URL.createObjectURL(this.VoiceMessage)
      }
    },
  },
  methods: {
    sendNewMessage() {
      this.$emit('sendNewMessage', this.content);
    },
    submitChatMediaModal(){
      this.$emit('sendNewMedia', this.media);
    },
    // Upload Picture
    async uploadMedia() {
      let _this = this;
      let formData = new FormData;
      let upFile = _this.$refs.chatMedia.files[0];
      formData.append('mainFile', upFile);
      let createFile = new MediaCreateOnlineChatMediaRequest(_this);
      createFile.setParams(formData);
      await createFile.sendFormData((content) => {
        _this.media.file = Helper.baseUrl+'media/gallery/onlineChat/'+content.data;
        _this.media.type = 2;
      }, (error) => {});
    },
    // Upload Voice
    StartRecording() {
      this.IsRecording = true
      if (this.IsRecording) {
        this.AudioStopWatch = setInterval(() => {
          this.Seconds++
          if (this.Seconds === 59) {
            this.Seconds = 0
            this.Minutes++
            if (this.Minutes === 59) {
              this.Hours++
            }
          }
        }, 1000)
        this.$refs.Recorder.startRecording()
      }
    },
    StopRecording() {
      clearInterval(this.AudioStopWatch)
      this.IsRecording = false
      this.Seconds = 0
      this.Hours = 0
      this.Minutes = 0
      this.$refs.Recorder.stopRecording()
      this.showVoiceSubmit = false;
    },
    SetAudioBlob(blob) {
      this.VoiceMessage = blob;
    },
    async uploadVoice() {
      let _this = this;
      let formData = new FormData;
      let upFile = _this.VoiceMessage;
      formData.append('mainFile', upFile , 'voice.wav');
      let createFile = new MediaCreateOnlineChatMediaRequest(_this);
      createFile.setParams(formData);
      await createFile.sendFormData((content) => {
        _this.media.file = Helper.baseUrl+'media/gallery/onlineChat/'+content.data;
        _this.media.type = 3;
        _this.submitChatMediaModal();
        _this.closeVoiceModal();
      }, (error) => {});
    },
    closeVoiceModal(){
      this.showVoiceModal = false;
      this.VoiceMessage = '';
      this.media.file = null;
      this.IsRecording = false;
      this.showVoiceSubmit = true;
    },
    clearMessage() {
      this.content = '';
      this.media.file = null;
    }
  },
  components: {
    AudioRecorder,
    BFormTextarea,
    ChatHeader,
    VuePerfectScrollbar,
    EmojiPicker,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BAlert,
    BMedia,
    BAvatar,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
  },
}
</script>

<style >
.emoji-container {
  position: absolute;
  bottom: 100%;
  left: 0;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.blob {
  background: #FF5252B2;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  margin: 10px;
  height: 20px;
  width: 20px;
  transform: scale(1);
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
</style>
